<template>
    <AuthLayout>
        <div class="alert alert-success text-center h4" role="alert">
            You're now on the <b>Settings Page</b>, that's still under construction. Sorry for the inconvenience.
        </div>
    </AuthLayout>
</template>

<script>

    export default {
        name: 'Settings',

        computed: {
            
        },
    }
</script>